module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAB8SURBVHgB7ZPBDYAgDEVbOwVrwAJupqs5AHMwhsqBi6lpixpj7E96gND3DrQAnjsTY5xqWXpI+7CCEXHeawwhQCll0fSpBA3ezhaJKDjCrRLqgVsk1AvXSugKXCNBDSCltHL3OWexf4CH44L3Bd8PO8dncy+F2wv/gx9kA7EMK/NoPFJyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/sidebarIcon/downloadIcon.png
// module id = 58
// module chunks = 1